import React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
  width?: string | number;
  height?: string | number;
}

const CloseBGGreySvg: React.FC<Props> = ({ width = 32, height = 32, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="16" fill="#E4E7E9" />
    <path
      d="M11.5906 10.4101C11.2651 10.0847 10.7375 10.0847 10.412 10.4101C10.0866 10.7355 10.0866 11.2632 10.412 11.5886L14.8228 15.9994L10.4121 20.4101C10.0866 20.7355 10.0866 21.2632 10.4121 21.5886C10.7375 21.914 11.2651 21.914 11.5906 21.5886L16.0013 17.1779L20.4121 21.5886C20.7375 21.9141 21.2651 21.9141 21.5906 21.5886C21.916 21.2632 21.916 20.7355 21.5906 20.4101L17.1798 15.9994L21.5906 11.5886C21.916 11.2632 21.916 10.7355 21.5906 10.4101C21.2651 10.0847 20.7375 10.0847 20.4121 10.4101L16.0013 14.8209L11.5906 10.4101Z"
      fill="#2A2D31"
    />
  </svg>
);
export default CloseBGGreySvg;
